import React from 'react';
import { audiobook, gutenberg } from '../data/siteContent';

const BooksSection: React.FC = () => {
  return (
    <section id="books" className="section-y">
      <div className="shell">
        <div className="max-w-2xl">
          <p className="kicker-action">{gutenberg.eyebrow}</p>
          <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[3rem]">{gutenberg.title}</h2>
          <p className="prose-reading mt-6">{gutenberg.body}</p>
        </div>

        <ul className="mt-14 grid list-none gap-px bg-ink/12 md:grid-cols-3">
          {gutenberg.sources.map((source) => (
            <li key={source.title} className="flex flex-col bg-background p-7 sm:p-8">
              <span className="inline-flex w-fit border border-primary/40 px-2 py-1 font-body text-[0.625rem] font-semibold uppercase tracking-small-caps text-primary">
                {source.badge}
              </span>
              <h3 className="display-sm mt-6 text-xl">{source.title}</h3>
              <p className="prose-note mt-3">{source.description}</p>
            </li>
          ))}
        </ul>

        {/* Read-along sits here rather than in its own section: it is a property
            of the books you bring, not a separate product surface. */}
        <div className="mt-gutter grid gap-10 border border-ink/15 bg-surface p-8 sm:p-11 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-7">
            <p className="kicker-action">{audiobook.eyebrow}</p>
            <h3 className="display-lg mt-4 text-[1.75rem] sm:text-[2.25rem]">{audiobook.title}</h3>
            <p className="prose-reading mt-5">{audiobook.body}</p>
          </div>

          <aside className="border-l-2 border-primary/40 pl-6 lg:col-span-5">
            <p className="kicker">In development</p>
            <p className="prose-note mt-3 text-[0.9375rem]">{audiobook.footnote}</p>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default BooksSection;
